import React from "react";
import FaqAccordion from "../faqAccordion/faqAccordion";

const Blog9 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>
        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        <p className="paragraph-content">
          Every month, something shows up that you didn’t plan for.
          <br />
          A school form fee. A small medical bill. A supplier asking for a quick
          advance.
          <br />
          And suddenly, that calm you were trying to hold onto? Gone.
        </p>

        <p className="sub-paragraph-heading">
          The real stress isn’t always lack of money.
        </p>

        <p className="paragraph-content">
          It’s not knowing when the next surprise will hit.
          <br />
        </p>

        <p className="paragraph-content">What if that could change?</p>

        <p className="paragraph-content">
          What if, quietly in the background, you had a system that made sure
          <br />
          “you’re covered” – without needing a big salary or big sacrifices?
        </p>

        <p className="sub-paragraph-heading">Why Most People Stay Stuck</p>

        <p className="paragraph-content">
          They try to plan big.
          <br />
          “I’ll start saving when things stabilize.”
          <br />
          <br />
          But stability never just… arrives.
          <br />
          <br />
          Prices keep rising.
          <br />
          Income feels tight.
          <br />
          And banks? Still stuck in forms and fine print.
          <br />
          <br />
          Meanwhile, small everyday stress eats away at your peace.
          <br />
          You think about saving, but it feels far. Complicated. Delayed.
        </p>

        <p className="sub-paragraph-heading">
          The Shift That Changes Everything
        </p>

        <p className="paragraph-content">
          What if you stopped chasing big plans…
          <br />
          And just automated a small one?
          <br />
          <br />
          That’s what kPaisa was built for.
          <br />
          It lets you start micro-savings and gold investments –
          <br />
          From low amounts.
          <br />
          No drama. No pressure.
          <br />
          Just one small habit running quietly in the background.
          <br />
          <br />
          You can set it once:
          <br />
          A weekly or monthly auto-save
          <br />
          Into digital gold or mutual funds
          <br />
          – and forget it’s even happening.
          <br />
          <br />
          But when you check back?
          <br />
          You’ll see gold grams stacked.
          <br />
          A fund quietly growing.
          <br />
          Your own backup plan is taking shape.
          <br />
          <br />
          This is how real stability begins – not with a windfall. With a
          system.
        </p>

        <p className="sub-paragraph-heading">
          It Doesn’t Take Much to Feel the Shift
        </p>

        <p className="paragraph-content">
          Want to feel in control again?
          <br />
          <a
            href="https://kleio.app.link/download"
            target="_blank"
            rel="noreferrer"
            style={{ color: "#1155cc", textDecoration: "underline" }}
          >
            Start with one move today
          </a>
          .
          <br />
          Not tomorrow. Not next month.
          <br />
          Today.
          <br />
          Because the habit isn’t about how much.
          <br />
          It’s about knowing you finally did something for your future.
          <br />
          <br />
          There’s one feature inside the{" "}
          <a
            href="https://kleio.app.link/download"
            target="_blank"
            rel="noreferrer"
            style={{ color: "#1155cc", textDecoration: "underline" }}
          >
            kPaisa app
          </a>{" "}
          that silently turns leftovers into your emergency stash. Most people
          miss it – but the smart ones start with it.
          <br />
          <br />
          Ever felt like your money disappears and you don’t know where?
          <br />
          There’s a setting inside kPaisa that fixes that – automatically.
          <br />
          Once you try it, you’ll wonder how you lived without it.
        </p>

        <div className="faq-heading-container">
          <p className="sub-paragraph-heading-faq">
            Frequently asked questions
          </p>
        </div>
        <FaqAccordion>
          <h4 className="faq-question">
            Can I start without putting in a big amount?
          </h4>
          <p className="faq-answer">
            Absolutely. The whole idea is small-ticket saving – even a few
            hundred rupees a month works.
          </p>
        </FaqAccordion>
        <FaqAccordion>
          <h4 className="faq-question">What if my income changes?</h4>
          <p className="faq-answer">
            Nothing breaks. The system adjusts. You’re always in control.
          </p>
        </FaqAccordion>

        <br></br>
        <br></br>
      </div>
    </div>
  );
};

export default Blog9;
